import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getMsalConfig } from './authConfig';
import { getConfig } from './services/config';
import { initAuthService } from './services/auth';

// Loading component while config is being fetched
function LoadingApp() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Roboto, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div>Loading configuration...</div>
        <div style={{ marginTop: '20px' }}>
          <svg width="40" height="40" viewBox="0 0 50 50" style={{ animation: 'spin 1s linear infinite' }}>
            <circle cx="25" cy="25" r="20" fill="none" stroke="#1976d2" strokeWidth="4" strokeDasharray="31.4 31.4" />
          </svg>
        </div>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// Initialize app asynchronously
async function initializeApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  try {
    // Show loading screen
    root.render(<LoadingApp />);

    // Load runtime configuration
    await getConfig();

    // Get MSAL configuration
    const msalConfig = await getMsalConfig();

    // Initialize MSAL instance
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();

    // Get current accounts
    const accounts = msalInstance.getAllAccounts();

    // Initialize auth service with MSAL instance
    initAuthService(msalInstance, accounts);

    // Render app with MSAL provider
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    root.render(
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Roboto, sans-serif',
        color: '#d32f2f'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '500px', padding: '20px' }}>
          <h2>Initialization Error</h2>
          <p>{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }
}

// Start the app
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Deployment test - 1763820832
